// extracted by mini-css-extract-plugin
export default {"view_table":"ComplexTypeTable_view_table__gJwIB","max_w_10":"ComplexTypeTable_max_w_10__r+8Yg"};